import React from 'react';
import Header from '../Comman/Header';
import Sidebar from '../Comman/Sidebar';
import { LuHeadset, LuMail, LuPlus, LuList, LuShield } from "react-icons/lu";
import { Link } from 'react-router-dom';

function SupportPage() {
    const CSS = `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        .db-scene {
            background: #e8ecf1;
            min-height: 100vh;
            font-family: 'Inter', -apple-system, sans-serif;
            padding: 28px 20px;
            color: #1e293b;
            position: relative;
            overflow-x: hidden;
            perspective: 1600px;
        }

        .db-scene::before {
            content: '';
            position: fixed;
            top: -10%; right: -10%; width: 500px; height: 500px;
            background: radial-gradient(circle, rgba(0,111,227,0.05) 0%, transparent 70%);
            border-radius: 50%; filter: blur(80px);
            animation: dbOrb1 20s ease-in-out infinite; pointer-events: none;
        }
        @keyframes dbOrb1 { 0%,100%{transform:translate(0,0)} 50%{transform:translate(-40px,30px)} }

        .db-profile-card {
            position: relative;
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(25px);
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-radius: 44px;
            padding: 40px;
            transform-style: preserve-3d;
            transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1);
            box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
            overflow: hidden;
            margin-bottom: 40px;
        }

        .db-profile-card::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 44px;
            padding: 2px;
            background: conic-gradient(from var(--angle), transparent 70%, #006fe3, #00ffff, #006fe3, transparent);
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            animation: dbRotateAngle 4s linear infinite;
            z-index: 5;
            pointer-events: none;
        }
        @property --angle { syntax: '<angle>'; initial-value: 0deg; inherits: false; }
        @keyframes dbRotateAngle { from { --angle: 0deg; } to { --angle: 360deg; } }

        .db-card-border-anim {
            position: absolute;
            bottom: 0; left: 0; right: 0; height: 4px;
            background: linear-gradient(90deg, #006fe3, #8b5cf6, #f59e0b, #006fe3);
            background-size: 300% 100%;
            animation: dbBorderRun 4s linear infinite;
            z-index: 10;
        }
        @keyframes dbBorderRun { 0%{background-position:0% 50%} 100%{background-position:100% 50%} }

        .db-tile {
            background: rgba(255, 255, 255, 0.65);
            backdrop-filter: blur(15px);
            border-radius: 30px;
            padding: 30px 24px;
            border: 1px solid rgba(255, 255, 255, 0.4);
            display: flex;
            align-items: center;
            gap: 16px;
            position: relative;
            overflow: hidden;
            transform-style: preserve-3d;
            transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
            box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
            height: 100%;
            text-decoration: none;
        }

        .db-tile:hover {
            background: rgba(255, 255, 255, 0.85);
            transform: translateY(-5px);
            box-shadow: 0 30px 60px rgba(0,0,0,0.1), 20px 30px 60px rgba(163, 177, 198, 0.5);
        }

        .db-icon {
            width: 54px;
            height: 54px;
            border-radius: 16px;
            background: #f8fafc;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            transition: all 0.5s cubic-bezier(0.23,1,0.32,1);
            box-shadow: 4px 4px 10px rgba(0,0,0,0.08), -4px -4px 10px #ffffff, inset 2px 2px 4px rgba(0,0,0,0.05);
            color: #006fe3;
            font-size: 24px;
            transform: translateZ(20px);
        }

        .db-tile:hover .db-icon {
            transform: translateZ(40px) rotateY(360deg);
            background: linear-gradient(135deg, #006fe3, #003d7a);
            color: white;
            box-shadow: 0 10px 20px rgba(0, 111, 227, 0.3);
        }

        .db-tile-text h4 {
            font-size: 17px;
            font-weight: 700;
            color: #1e293b;
            margin: 0;
        }
        .db-tile-text p {
            margin: 2px 0 0;
            font-size: 12px;
            color: #94a3b8;
            font-weight: 600;
            text-transform: uppercase;
        }

        .support-hero-content {
            display: flex;
            align-items: center;
            gap: 25px;
            z-index: 10;
            position: relative;
        }

        .support-avatar-wrap {
            width: 90px;
            height: 90px;
            background: linear-gradient(135deg, #006fe3, #003d7a);
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 36px;
            box-shadow: 8px 8px 20px rgba(0, 111, 227, 0.3), inset 0 2px 4px rgba(255,255,255,0.4);
            animation: dbAvatarFloat 4s ease-in-out infinite;
            transform-style: preserve-3d;
        }
        @keyframes dbAvatarFloat { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }

        .db-sec-hdr {
            display:flex; align-items:center; gap:12px;
            margin-bottom:24px; padding-bottom:12px;
            border-bottom:2px solid rgba(0,0,0,0.04);
            position:relative;
        }
        .db-sec-hdr::after {
            content:''; position:absolute; bottom:-2px; left:0; width:60px; height:3px;
            background: linear-gradient(90deg, #006fe3, #0058b0); border-radius:3px;
        }
        .db-sec-dot {
            width:8px; height:8px; border-radius:50%;
            background:#006fe3; box-shadow:0 0 8px rgba(0,111,227,0.5);
            animation: dbDotPulse 2s ease-in-out infinite;
        }
        @keyframes dbDotPulse { 0%,100%{box-shadow:0 0 8px rgba(0,111,227,0.5)} 50%{box-shadow:0 0 18px rgba(0,111,227,0.8)} }
        .db-sec-title { font-size:16px; font-weight:700; text-transform:uppercase; letter-spacing:1.5px; color:#1e293b; }

        .protocol-pill {
            background: rgba(238, 242, 246, 0.5);
            border-radius: 20px;
            padding: 20px;
            margin-bottom: 16px;
            display: flex;
            gap: 15px;
            transition: all 0.3s;
            border: 1px solid rgba(255, 255, 255, 0.8);
            box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
        }
        .protocol-pill:hover {
            background: #ffffff;
            box-shadow: 0 12px 0 #bfc9d8, 0 30px 60px rgba(0, 0, 0, 0.1);
        }
        .step-tag {
            background: linear-gradient(135deg, #006fe3, #003d7a);
            color: white;
            width: 34px; height: 34px;
            border-radius: 10px;
            display: flex; align-items: center; justify-content: center;
            font-weight: 800; font-size: 14px; flex-shrink: 0;
            box-shadow: 4px 4px 10px rgba(0,111,227,0.2);
        }

        .response-tag {
            background: rgba(238, 242, 246, 0.5);
            border-radius: 20px;
            padding: 10px 20px;
            border: 1px solid rgba(255, 255, 255, 0.8);
            box-shadow: 1px 20px 20px 0px #bfc9d8;
            font-size: 11px;
            font-weight: 800;
            color: #006fe3;
            letter-spacing: 1px;
            text-transform: uppercase;
        }

        /* --- RESPONSIVE FIXES --- */
        @media (max-width: 991px) {
            .db-profile-card { padding: 30px; border-radius: 35px; }
            .support-hero-content { flex-direction: column; text-align: center; gap: 20px; }
            .db-scene { padding: 15px 10px; }
        }

        @media (max-width: 576px) {
             .db-tile { padding: 20px 15px; border-radius: 20px; }
             .db-tile h4 { font-size: 14px !important; }
             .db-sec-title { font-size: 13px; }
             .db-profile-card h1 { font-size: 24px !important; }
             .target-cat-tile { padding: 15px !important; gap: 10px !important; }
             .target-cat-tile p { font-size: 9px !important; }
             .target-cat-tile h4 { font-size: 13px !important; }
        }
    `;

    return (
        <div className="body-bg">
            <style>{CSS}</style>
            <Sidebar />
            <Header />
            <section className="nftmax-adashboard nftmax-show">
                <div className="db-scene" style={{ borderRadius: '29px' }}>
                    <div className="container">
                        {/* Hero Header Card */}
                        <div className="db-profile-card">
                            <div className="db-card-border-anim" />
                            <div className="support-hero-content">
                                <div className="support-avatar-wrap">
                                    <LuHeadset />
                                </div>
                                <div className="flex-grow-1">
                                    <p className="mb-1 fw-bold text-uppercase" style={{ letterSpacing: '2px', fontSize: '13px', color: '#64748b' }}>Technical Support</p>
                                    <h1 className="mb-0 fw-black h2" style={{ fontWeight: 900, color: '#1e293b', fontSize: '32px' }}>Support Center</h1>
                                    <p className="mb-0 mt-1 opacity-75 fw-semibold" style={{ color: '#006fe3', fontSize: '15px' }}>We're here to help you 24/7</p>
                                </div>
                                <div className="d-none d-md-block text-end">
                                    <div className="response-tag">Response: 48-72 Hours</div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Tiles */}
                        {/* <div className="db-sec-hdr">
                            <div className="db-sec-dot" />
                            <div className="db-sec-title">Contact Channels</div>
                        </div>
                        <div className="row g-4 mb-5">
                            <div className="col-lg-4">
                                <a href="mailto:inquiry@getlink.com" className="db-tile">

                                    <span className="db-input-icon-box icon-cyan"><LuMail /></span>
                                    <div className="db-tile-text">
                                        <p>Official Inquiry</p>
                                        <h4>inquiry@getlink.com</h4>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-4">
                                <a href="mailto:support@getlink.com" className="db-tile">
                                    <span className="db-input-icon-box icon-cyan"><LuHeadset /></span>
                                    <div className="db-tile-text">
                                        <p>Tech Support</p>
                                        <h4>support@getlink.com</h4>
                                    </div>
                                </a>
                            </div>
                            <div className="col-lg-4">
                                <a href="mailto:complaint@getlink.com" className="db-tile">
                                    <span className="db-input-icon-box icon-cyan"><LuShield /></span>
                                    <div className="db-tile-text">
                                        <p>Grievance</p>
                                        <h4>complaint@getlink.com</h4>
                                    </div>
                                </a>
                            </div>
                        </div> */}

                        {/* Action Grid */}
                        <div className="row g-4 mb-5">
                            <div className="col-md-6">
                                <div className="db-profile-card" style={{ padding: '30px', borderRadius: '44px' }}>
                                    <span className="db-input-icon-box icon-cyan mb-4"><LuPlus /></span>
                                    <h3 className="fw-900 h4 mb-2" style={{ fontWeight: 800 }}>Initialize Ticket</h3>
                                    <p className="text-secondary" style={{ fontSize: '14px' }}>Launch formal inquiry for technical anomalies or ledger inquiries.</p>
                                    <div className="mt-4 pt-2 border-top">
                                        <Link to="/support/create-ticket" className="btn btn-primary rounded-pill px-4" style={{ background: '#006fe3', border: 'none', fontWeight: 700, padding: '12px' }}>Create New Ticket</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="db-profile-card" style={{ padding: '30px', borderRadius: '44px' }}>
                                    <span className="db-input-icon-box icon-cyan mb-4"><LuList /></span>
                                    <h3 className="fw-900 h4 mb-2" style={{ fontWeight: 800 }}>Monitor Registry</h3>
                                    <p className="text-secondary" style={{ fontSize: '14px' }}>Review and track the status of your existing protocol inquiries.</p>
                                    <div className="mt-4 pt-2 border-top">
                                        <Link to="/support/my-tickets" className="btn btn-primary rounded-pill px-4" style={{ background: '#f59e0b', border: 'none', fontWeight: 700, padding: '12px' }}>View My Tickets</Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Information Sections */}
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="db-profile-card" style={{ borderRadius: '44px' }}>
                                    <div className="db-sec-hdr">
                                        <div className="db-sec-title">Support Protocol</div>
                                    </div>
                                    <div className="protocol-pill">
                                        <span className="db-input-icon-box icon-cyan">01</span>
                                        <div>
                                            <h5 className="fw-bold mb-1">Initialization</h5>
                                            <p className="small text-secondary mb-0">Securely authenticate and define nature of inquiry.</p>
                                        </div>
                                    </div>
                                    <div className="protocol-pill">
                                        <span className="db-input-icon-box icon-cyan">02</span>
                                        <div>
                                            <h5 className="fw-bold mb-1">Validation</h5>
                                            <p className="small text-secondary mb-0">Support operatives verify and cross-reference logs.</p>
                                        </div>
                                    </div>
                                    <div className="protocol-pill">
                                        <span className="db-input-icon-box icon-cyan">03</span>
                                        <div>
                                            <h5 className="fw-bold mb-1">Resolution</h5>
                                            <p className="small text-secondary mb-0">Direct engagement until the anomaly is rectified.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="db-profile-card" style={{ borderRadius: '44px' }}>
                                    <div className="db-sec-hdr">
                                        <div className="db-sec-title">Target Categories</div>
                                    </div>
                                    <div className="row g-3">
                                        <div className="col-12 col-sm-6">
                                            <div className="db-tile target-cat-tile">
                                                <span className="db-input-icon-box icon-cyan">💰</span>
                                                <div className="db-tile-text">
                                                    <p>Financial</p>
                                                    <h4>Ledger Sync</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="db-tile target-cat-tile">
                                                <span className="db-input-icon-box icon-cyan">🔐</span>
                                                <div className="db-tile-text">
                                                    <p>Access</p>
                                                    <h4>Auth Security</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="db-tile target-cat-tile">
                                                <span className="db-input-icon-box icon-cyan">⚙️</span>
                                                <div className="db-tile-text">
                                                    <p>Technical</p>
                                                    <h4>Core Errors</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="db-tile target-cat-tile">
                                                <span className="db-input-icon-box icon-cyan">❓</span>
                                                <div className="db-tile-text">
                                                    <p>General</p>
                                                    <h4>Info Request</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </div >
    );
}

export default SupportPage;


